"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bootstrap3_1 = require("./bootstrap3");
exports.default = {
    bootstrap3: bootstrap3_1.default,
};
